import {
    selectUamApiKey,
    selectUamApiUrl,
    selectUamAuthHolderToken,
    selectUamAuthToken,
} from '../../state/selectors/uamData';
import arrayUtils from '../../utils/arrayUtils';
import stringUtils from '../../utils/stringUtils';
import urlUtils from '../../utils/urlUtils';
import server from '../server/server';

export default class UamClient {
    getHeaders = async (isHolder, uamTokenData) => {
        const {uamApiKey: apiKey, uamAuthToken: authToken} = uamTokenData || {};
        const idToken = authToken || (isHolder ? selectUamAuthHolderToken() : selectUamAuthToken());

        if (!idToken) throw new Error(`Uam token is missing isHolder: ${isHolder}`);

        const headers = {
            Accept: 'application/json',
            id_token: idToken,
        };

        const xApiKey = apiKey || selectUamApiKey();

        if (xApiKey) {
            headers['X-API-Key'] = xApiKey;
        }

        return headers;
    };

    getApiUrl = (methodName, uamTokenData) => {
        const {uamApiUrl: apiUrl} = uamTokenData || {};
        const uamApiUrl = apiUrl || selectUamApiUrl();

        return urlUtils.join(uamApiUrl, methodName);
    };

    getMethodUrl = ({methodName, requestConfig}) => {
        const args = requestConfig?.args;
        let methodUrl = methodName;

        if (args) {
            const params = arrayUtils.toArray(args);

            methodUrl = stringUtils.formatString(methodName, ...params);
        }
        return methodUrl;
    };

    callGet = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.get;
        return this.callRequest(options);
    };

    callPost = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.post;
        return this.callRequest(options);
    };

    callPut = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.put;
        return this.callRequest(options);
    };

    callRequest = async (params) => {
        try {
            const response = await this.callMethod(params);

            if (!response) return null;

            const {mapper} = params;
            let {data} = response;

            if (mapper) {
                data = mapper(data);
            }

            return data;
        } catch (e) {
            throw e;
        }
    };

    callMethod = async ({httpMethod, methodUrl, requestConfig, isHolder, uamTokenData}) => {
        const url = this.getApiUrl(methodUrl, uamTokenData);
        const headers = await this.getHeaders(isHolder, uamTokenData);
        const params = requestConfig?.params ? requestConfig?.params : {};
        const data = requestConfig?.data ? requestConfig.data : {};

        return await httpMethod(url, {headers, params, data});
    };
}
